import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Pagination,
  PaginationItem,
  Paper,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  CircularProgress,
  Backdrop
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import CustomTextField from "../../CustomComponents/CustomTextField";
import { useSelector, useDispatch } from "react-redux";
import CustomDataGrid from "../../CustomComponents/CustomDataGrid";
import { FilePaymentModifyReducerAction } from "../../Store/FilePayment/FilePaymentModifyReducer";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CustomDateField from "../../CustomComponents/CustomDateField";
import axios from "axios";
import { ArrowBack, ArrowForward, Delete } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import store from "../../Store";
import SaveIcon from "@mui/icons-material/Save";
import CustomAutoComplete from "../../CustomComponents/CustomAutoComplete";
import { CommonShortCutAction } from "../../Store/CommonShortCutsReducer";
import dayjs from "dayjs";
import GetBranchDetailsWithCode from "../../CustomComponents/GetBranchDetailsWithCode";

const FilePaymentDet = () => {
  //Use Dispatch)
  const dispatch = useDispatch();
  //Code which maintain opening and closing Dialog
  const [Dialogopen, setDialogOpen] = useState(false);
  const [yesButtonDisableHandler, setYesButtonDisableHandler] = useState(false);

  //Maintaining Selected RowID
  const [activeRowID, setActiveRowID] = useState("");
  //Rmarks values
  const deleteRemarks = useSelector(
    (state) => state.filePaymentModify.remarks.deleteRemarks
  );
  const [accordianOpen, setAccordianOpen] = useState(true);
  const deleteRemarksTouchHandler = useSelector(
    (state) => state.filePaymentModify.remarks.remarksTouchHandler
  );

  const deleteRemarksIsValid = deleteRemarks !== "" && deleteRemarks !== null;
  const deleteRemarksHasError =
    !deleteRemarksIsValid && deleteRemarksTouchHandler;
  //Getting modal value for binding record on the model
  const modalValues = useSelector(
    (state) => state.filePaymentModify.modalValue
  );
  const GLAccountArray = useSelector(
    (state) => state.filePaymentModify.gridValues.GLAccountArray
  );
  const GLResponseData = useSelector(
    (state) => state.filePaymentModify.gridValues.GLValAndDesArray
  );
  const allBranchGlAccounts = useSelector(
    (state) => state.filePaymentModify.gridValues.allBranchGlAccounts
  );
  let applicationArray = useSelector(
    (state) => state.filePaymentModify.gridValues.applicationNumberArray
  );

  //maintaining Debit Amount
  const Gldes = useSelector(
    (state) => state.filePaymentModify.validation.Gldes
  );
  const voucherNumber = useSelector(
    (state) => state.filePaymentModify.filterValues.voucherNumberValue
  );
  const filterValues = useSelector(
    (state) => state.filePaymentModify.filterValues
  );
  const bankDetails = useSelector(
    (state) => state.filePaymentModify.CustomerBankDetails
  );
  const emiResponse = useSelector(
    (state) => state.filePaymentModify.customerEmiData
  );
  // use same constant to disbale the save btn on API request on delete, modify & Approve Modes.
  const [saveRequestActive, setSaveRequestActive] = useState(false);

  //Getting UserName
  const [userName, setUserName] = useState("");
  const newRowValues = useSelector((state) => state.filePaymentModify.newRow);
  const rows = useSelector((state) => state.filePaymentModify.gridValues.rows);
  const initialResponseRowValue = useSelector(
    (state) => state.filePaymentModify.filterValues.initialResponseRowValue
  );
  const [loanClosed, setLoanClosed] = useState(false);
  const rowsPerPage = 10;
  const [page, setPage] = React.useState(1);
  const [datarows, setRows] = React.useState([]);
  const [totalRowsCount, setTotalRowsCount] = React.useState(0);
  const [totalPageCount, setTotalPageCount] = React.useState(0);
  //code for maintaining validation dialog
  const [validationDialogOpen, setValidationDialogOpen] = useState(false);
  const [validationDialogTitle, setValidationDialogTitle] = useState("");
  const [validationDialogContent, setValidationDialogContent] = useState("");
  const [informationDialogOkButton, setinformationDialogOkButton] =
    useState(true);
  const [dialogTitleMode, setDialogTitleMode] = useState("");
  //State for maintaining Confirmation Dialog
  const [confirmationDialogOpen, setConfirmationDialogopen] = useState(false);
  const [confirmationDialogTitle, setConfirmationDialogTitle] = useState("");
  const [confirmationDialogContent, setConfirmationDialogContent] =
    useState("");
  //Dialog mode
  const [informationDialogFlag, setInformationDialogFlag] = useState(false);
  const [informationDialogTitle, setInformationDialogTitle] = useState("");
  const brachArrayWithCode = useSelector(
    (state) => state.filePaymentModify.filterValues.brachArrayWithCode
  );
  const approvalFlag = useSelector(
    (state) => state.filePaymentMode.mode.approvalFlag
  );
  const screenMode = useSelector(
    (state) => state.filePaymentModify.modes.screenMode
  );
  const [pageSize, setPageSize] = useState(10);
  const [column, setColumn] = useState([]);

  const [loading, setLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState(
    "Loading Data Please Wait ....."
  );

  //shortcut key
  const yesDetRef = useRef(null);
  const cancelDetRef = useRef(null);
  const okInfoRef = useRef(null);
  const okRef = useRef(null);
  const okValRef = useRef(null);
  const saveApproveRef = useRef(null);
  const saveDeleteRef = useRef(null);
  const addRowRef = useRef(null);
  const saveUpdateRef = useRef(null);
  useEffect(() => {
    if (screenMode !== "EditScreen") {
      const filteredColumns = columnsData.filter(
        (data) => data.field !== "icon"
      );
      setColumn(filteredColumns);
    } else {
      setColumn(columnsData);
    }
  }, [screenMode, applicationArray]);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, [dialogTitleMode, informationDialogOkButton]);
  const checkGlPaymentReceipt = async (appNum, glAccount) => {
    try {
      const response = await axios.post("/filepayment/checkPaymentGlReceipt", {
        applicationNum: appNum,
        glAccount: glAccount,
      });
      return response;
    } catch (e) {
      console.log("Network Error");
    }
  };
  const checkPaymentGlReceiptAmount = async (appNum, glAccount, amount) => {
    try {
      const response = await axios.post(
        "/filepayment/checkPaymentGlReceiptAmount",
        {
          applicationNum: appNum,
          glAccount: glAccount,
          amount: amount,
        }
      );
      return response;
    } catch (e) {
      console.log("Network Error");
    }
  };
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "paymentModeDetail",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.key === "Escape" || event.keyCode === 27) {
      if (dialogTitleMode === "BankDetails") {
        setDialogOpen(false);
      }
      if (dialogTitleMode === "ValidationDialogMode") {
        if (informationDialogOkButton) {
          setValidationDialogOpen(false);
        } else {
          window.location.reload(true);
          setValidationDialogOpen(false);
        }
      }
      if (dialogTitleMode === "ConfirmationDialogMode") {
        setConfirmationDialogopen(false);
      }
    } else if (event.ctrlKey) {
      switch (charCode) {
        case "y":
          yesDetRef.current.click();
          break;
        case "q":
          cancelDetRef.current.click();
          break;
        case "k":
          okInfoRef.current?.click();
          okRef.current?.click();
          okValRef.current?.click();
          break;
        case "s":
          saveApproveRef.current?.click();
          saveDeleteRef.current?.click();
          saveUpdateRef.current?.click();
          break;
        case "a":
          addRowRef.current.click();
          break;
      }
    }
  };
  //Method for updating bank details modal value
  const customerBankDetailDialogHandler = (params) => {
    dispatch(FilePaymentModifyReducerAction.updateModalValue(params.row));
    setDialogTitleMode("BankDetails");
    setDialogOpen(true);
  };
  //Add Button Handler
  const gridRowAddButtonHandler = () => {
    if (rows.length > 0) {
      let result = true;
      rows.forEach((obj) => {
        Object.keys(obj).forEach((key) => {
          if (
            ![
              "emiStartDate",
              "emiAmt",
              "fundTransferMode",
              "filePaymentFavourId",
              "narration",
            ].includes(key)
          ) {
            if (
              obj[key] === "" ||
              obj[key] === undefined ||
              obj[key] === null
            ) {
              result = false;
            }
          }
        });
      });
      if (result) {
        dispatch(FilePaymentModifyReducerAction.updateGLAccountArray([]));
        dispatch(
          FilePaymentModifyReducerAction.addRows({
            id: Math.floor(Math.random() * 100),
            voucherNumber: voucherNumber,
            branch: filterValues.branchValueFromResponse,
            filePaymentHeaderKey: newRowValues.filePaymentHeaderKey,
            applicationNumber: filterValues.applicationNumberValue,
            //voucherType: newRowValues.voucherType,
            voucherDate: filterValues.voucherDate,
            paymentType: filterValues.paymentType,
            paymentCode: filterValues.paymentCode,
            branchCode: filterValues.branchCode,
            applicationBranchCode: filterValues.branchCode,
            applicationBranch: filterValues.branchValueFromResponse,
            fundTransferMode: filterValues.fundTransferMode,
            paymentBankOrCash: filterValues.paymentBankOrCash,
            // paymentBankCode: filterValues.paymentBankCode,
            filePaymentFavourId: null,
            glAccount: "",
            description: "",
            debitAmount: "",
            customerName: bankDetails.customerName,
            bankName: bankDetails.bankName,
            bankBranchName: bankDetails.bankBranchName,
            ifsc: bankDetails.ifsc,
            bankAccNum: bankDetails.bankAccNum,
            accountType: bankDetails.accountType,
            emiAmt: emiResponse.emiAmt,
            emiStartDate: emiResponse.emiStartDate,
            approvalFlg: newRowValues.approvalFlg,
            screenMode: "MODIFY",
            // sequenceNum: newRowValues.sequenceNum,
            createdBy: userName,
            lastModifiedBy: userName,
          })
        );
      } else {
        setinformationDialogOkButton(true);
        setValidationDialogTitle("Information");
        setValidationDialogContent("Please Enter all Required Fields");
        setDialogTitleMode("ValidationDialogMode");
        setValidationDialogOpen(true);
      }
    } else {
      dispatch(FilePaymentModifyReducerAction.updateGLAccountArray([]));
      dispatch(
        FilePaymentModifyReducerAction.addRows({
          id: Math.floor(Math.random() * 100),
          voucherNumber: voucherNumber,
          branch: filterValues.branchValueFromResponse,
          filePaymentHeaderKey: newRowValues.filePaymentHeaderKey,
          applicationNumber: filterValues.applicationNumberValue,
          //voucherType: newRowValues.voucherType,
          voucherDate: filterValues.voucherDate,
          paymentType: filterValues.paymentType,
          paymentCode: filterValues.paymentCode,
          branchCode: filterValues.branchCode,
          applicationBranchCode: filterValues.branchCode,
          applicationBranch: filterValues.branchValueFromResponse,
          fundTransferMode: filterValues.fundTransferMode,
          paymentBankOrCash: filterValues.paymentBankOrCash,
          // paymentBankCode: filterValues.paymentBankCode,
          filePaymentFavourId: null,
          glAccount: "",
          description: "",
          debitAmount: "",
          customerName: bankDetails.customerName,
          bankName: bankDetails.bankName,
          bankBranchName: bankDetails.bankBranchName,
          ifsc: bankDetails.ifsc,
          bankAccNum: bankDetails.bankAccNum,
          accountType: bankDetails.accountType,
          emiAmt: emiResponse.emiAmt,
          emiStartDate: emiResponse.emiStartDate,
          approvalFlg: newRowValues.approvalFlg,
          screenMode: "MODIFY",
          // sequenceNum: newRowValues.sequenceNum,
          createdBy: userName,
          lastModifiedBy: userName,
        })
      );
    }
  };
  const handlePageChange = (event, newPage) => {
    let offset = (newPage - 1) * rowsPerPage;
    setPage(newPage);

    setRows([...rows].slice(offset, offset + rowsPerPage));
  };

  useEffect(() => {
    setRows([...rows].slice(0, 10));
    setTotalPageCount(
      rows.length % 10 !== 0
        ? Number(Number((rows.length / 10).toString().split(".")[0]) + 1)
        : Number(Number((rows.length / 10).toFixed()))
    );
    setTotalRowsCount(rows.length);

    setPage(1);
  }, [rows]);

  const confirmationDialogYesButtonHandler = () => {
    setConfirmationDialogopen(false);
    //setYesButtonDisableHandler(true);
    if (screenMode === "EditScreen") {
      updateButtonHandler();
    }
    if (screenMode === "DeleteScreen") {
      deleteButtonHandler();
    }
    if (screenMode === "ApprovalScreen") {
      handleApprovalAndHosttoHostTransfer();
    }
  };
  useEffect(() => {
    const users = store.getState().branch.userName;
    setUserName(users);
  }, []);

  let compareTwoArrayOfObjects = (obj1, obj2) => {
    return (
      obj1.length === obj2.length &&
      obj1.every((element_1) =>
        obj2.some((element_2) =>
          Object.keys(element_1).every(
            (key) => element_1[key] === element_2[key]
          )
        )
      )
    );
  };
  const UpdateBtn = async () => {
    let result = true;
    rows.forEach((obj) => {
      Object.keys(obj).forEach((key) => {
        if (
          ![
            "emiStartDate",
            "emiAmt",
            "fundTransferMode",
            "filePaymentFavourId",
            "narration",
          ].includes(key)
        ) {
          if (obj[key] === "" || obj[key] === undefined || obj[key] === null) {
            result = false;
          }
        }
      });
    });
    if (result) {
      const result = compareTwoArrayOfObjects(initialResponseRowValue, rows);
      if (result) {
        setinformationDialogOkButton(true);
        setValidationDialogTitle("Information");
        setValidationDialogContent("No Changes Made.");
        setDialogTitleMode("ValidationDialogMode");

        setValidationDialogOpen(true);
      } else {
        let debitStatusFlag = false;
        rows.forEach((data) => {
          if (data.debitAmount <= 0) {
            debitStatusFlag = true;
          }
        });
        if (debitStatusFlag) {
          setinformationDialogOkButton(true);
          setValidationDialogTitle("Information");
          setValidationDialogContent("Please Enter Valid Debit Amount");
          setDialogTitleMode("ValidationDialogMode");
          setValidationDialogOpen(true);
        } else {
          // before calling payment confirmation dialog to user validate the all the rows belongs to single customer ID.
          await isPaymentForMultiCustomerIdValidation();
        }
      }
    } else {
      setinformationDialogOkButton(true);
      setValidationDialogTitle("Information");
      setValidationDialogContent("Please Enter all Required Fields");
      setDialogTitleMode("ValidationDialogMode");
      setValidationDialogOpen(true);
    }
  };

  const isPaymentForMultiCustomerIdValidation = async () => {
    setSaveRequestActive(true);
    try {
      const response = await axios.post(
        "/filepayment/isPaymentMultiCustomerId",
        rows
      );
      if (response.status === 200) {
        const responseData = response.data;
        if (responseData.isMultiCustomerId) {
          // error case -> show error info dialog to user.
          setinformationDialogOkButton(true);
          setValidationDialogTitle("Information");
          setValidationDialogContent(
            "File Payment Not Allowed for Multiple Customer Id's."
          );
          setDialogTitleMode("ValidationDialogMode");
          setValidationDialogOpen(true);
          setSaveRequestActive(false);
        } else {
          //positive case proceed with user confirmation for save.
          setDialogTitleMode("ConfirmationDialogMode");
          setConfirmationDialogopen(true);
          setConfirmationDialogTitle("Confirmation");
          setConfirmationDialogContent("Confirmation for Payment Update ?");
        }
      }
    } catch (error) {
      setSaveRequestActive(false);
    }
  };

  const updateButtonHandler = async () => {
    setSaveRequestActive(true);
    try {
      setLoading(true)
      setLoadingMsg("Updating Payment Please wait...")
      const response = await axios.post("/filepayment/updateFilePayment", rows);
      if (response.status === 200) {
        setLoading(false)
        setConfirmationDialogopen(false);
        setinformationDialogOkButton(false);
        setValidationDialogTitle("Information");
        setValidationDialogContent("Payment Updated Successfully.");
        setDialogTitleMode("ValidationDialogMode");
        setSaveRequestActive(false);
        setValidationDialogOpen(true);
      } else {
        setLoading(false)
        setinformationDialogOkButton(true);
        setValidationDialogTitle("Information");
        setValidationDialogContent("Unable to Update Payment.");
        setDialogTitleMode("ValidationDialogMode");
        setSaveRequestActive(false);
        setValidationDialogOpen(true);
      }
    } catch (error) {
      setLoading(false)
      setSaveRequestActive(false);
    }
  };
  const deleteSelectedRow = (params) => {
    const filteredValue = rows.filter((data) => {
      return data.id !== params.id;
    });
    dispatch(FilePaymentModifyReducerAction.updateRows(filteredValue));
  };
  const deleteButton = () => {
    dispatch(FilePaymentModifyReducerAction.updateRemarksTouchHandler(true));
    if (deleteRemarksIsValid) {
      setDialogTitleMode("ConfirmationDialogMode");

      setConfirmationDialogopen(true);
      setConfirmationDialogTitle("Confirmation");
      setConfirmationDialogContent("Confirmation for Payment Delete ?");
    }
  };
  const deleteButtonHandler = async () => {
    setSaveRequestActive(true);
    try {
      setLoading(true)
      setLoadingMsg("Deleting Payment Please wait...")
      const response = await axios.post(
        "/filepayment/deleteFilePaymentVoucher",
        {
          voucherNum: voucherNumber,
          remarks: deleteRemarks,
        }
      );
      if (response.status === 200) {
        setLoading(false)
        setConfirmationDialogopen(false);
        setinformationDialogOkButton(false);
        setValidationDialogTitle("Information");
        setValidationDialogContent(`Payment Deleted Successfully.`);
        setDialogTitleMode("ValidationDialogMode");
        setSaveRequestActive(false);
        setValidationDialogOpen(true);
      } else {
        setLoading(false)
        setinformationDialogOkButton(true);
        setValidationDialogTitle("Information");
        setValidationDialogContent(`Unable to Delete the Payment.`);
        setDialogTitleMode("ValidationDialogMode");
        setSaveRequestActive(false);
        setValidationDialogOpen(true);
      }
    } catch {
      setLoading(false)
      setSaveRequestActive(false);
    }
  };
  const approvalBtn = () => {
    setDialogTitleMode("ConfirmationDialogMode");

    setConfirmationDialogopen(true);
    setConfirmationDialogTitle("Confirmation");
    setConfirmationDialogContent("Confirmation for Payment Approval ?");
  };
  const approvalButtonHandler = async () => {
    // get the first record in grid list for payment details.
    const latestRows = store.getState().filePaymentModify.gridValues.rows;
    const response = await axios.post("/filepayment/voucherApproved", {
      voucherNum: voucherNumber,
      approvalFlg: true,
      lastModifiedBy: userName,
    });
    if (response.status === 200) {
      setConfirmationDialogopen(false);
      setinformationDialogOkButton(false);
      setValidationDialogTitle("Information");
      setValidationDialogContent(`Payment Approved Successfully.`);
      setDialogTitleMode("ValidationDialogMode");
      setValidationDialogOpen(true);
    } else {
      setinformationDialogOkButton(true);
      setDialogTitleMode("ValidationDialogMode");
      setSaveRequestActive(false);
      setValidationDialogTitle("Information");
      setValidationDialogContent(`Unable to Approve Payment.`);
      setValidationDialogOpen(true);
    }
  };

  const handleApprovalAndHosttoHostTransfer = async () => {
    try {
      setLoading(true)
      setLoadingMsg("Approving Payment Please wait...")
      setSaveRequestActive(true);
      await Promise.all([approvalButtonHandler(), hostToHostDataTransfer()]);
      setSaveRequestActive(false);
      setLoading(false)
    } catch (error) {
      console.error("Error handling approval and Host to HostTransfer:", error);
      setSaveRequestActive(false);
      setLoading(false)
    }
  };

  const hostToHostDataTransfer = async () => {
    // get the first record in grid list for payment details.
    const latestRows = store.getState().filePaymentModify.gridValues.rows;
    let multiplePaymentModePayload = [];
    let currentRow = latestRows[0];
    let paramMap = {};
    let transactionType = "";
    let ifscCode = currentRow.ifsc;
    let hdfcIfsc = "HDFC";
    let latestFilterValues = store.getState().filePaymentModify.filterValues;
    const paymentMode = latestFilterValues.fundTransferMode;
    if (
      (paymentMode === "RTGS" || paymentMode === "NEFT") &&
      ifscCode.indexOf(hdfcIfsc) === 0
    ) {
      transactionType = "I";
    } else {
      switch (paymentMode) {
        case "RTGS":
          transactionType = "R";
          break;
        case "NEFT":
          transactionType = "N";
          break;
        default:
          break;
      }
    }
    let instrumentRefNumber = latestFilterValues.voucherNumberValue;
    paramMap.transactionType = transactionType;
    paramMap.beneficiaryCode = ifscCode.indexOf(hdfcIfsc) === 0 ? "I" : "";
    paramMap.beneficiaryAccountNumber = currentRow.bankAccNum;
    let instrumentAmount = latestRows.reduce(
      (accumulator, currentValue) => accumulator + currentValue.debitAmount,
      0
    );
    paramMap.instrumentAmount = instrumentAmount;
    paramMap.beneficiaryName = currentRow.customerName;
    paramMap.applicationNumber = currentRow.applicationNumber; //need to confirm
    paramMap.draweeLocation = ""; //need to confirm
    paramMap.printLocation = "";
    paramMap.beneAddress1 = "";
    paramMap.beneAddress2 = "";
    paramMap.beneAddress3 = "";
    paramMap.beneAddress4 = "";
    paramMap.beneAddress5 = "";
    paramMap.instructionReferenceNumber = "";
    paramMap.customerReferenceNumber = instrumentRefNumber;
    paramMap.paymentDetails1 = "";
    paramMap.paymentDetails2 = "";
    paramMap.paymentDetails3 = "";
    paramMap.paymentDetails4 = "";
    paramMap.paymentDetails5 = "";
    paramMap.paymentDetails6 = "";
    paramMap.paymentDetails7 = "";
    paramMap.chequeNumber = 0; //""
    paramMap.chqTrnDate = dayjs(new Date()).format("DD/MM/YYYY"); //need to ask
    paramMap.micrNumber = 0; //""
    paramMap.ifcCode = currentRow.ifsc; //
    paramMap.beneBankName = instrumentRefNumber;
    paramMap.beneBankBranchName = currentRow.bankBranchName;
    paramMap.beneficiaryEmailId = ""; // need to confirm;
    paramMap.createdBy = userName;
    paramMap.createdDate = dayjs(new Date()).format("DD/MM/YYYY");
    paramMap.voucherNum = instrumentRefNumber;
    paramMap.filePayment = true;
    paramMap.customerID = ""; // yet to do.
    multiplePaymentModePayload.push(paramMap);
    const response = await axios.post("/hostToHostTransfer/insertDataToHost", {
      multiplePaymentModePayload,
    });
    // if (response.status === 200) {
    //   downloadHostToHostFile(currentRow.applicationNumber, response.data);
    // }
  };
  const downloadHostToHostFile = async (applicationNumber, data) => {
    let fileName = data.fileName;
    const response = await axios.get("/hostToHostTransfer/getFile", {
      method: "get",
      params: {
        applicationNumber: applicationNumber,
        fileName: fileName,
      },
      responseType: "blob",
    });
    if (response.status === 200) {
      let data = response.data;
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", `${fileName}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const columnsData = [
    {
      field: "applicationBranch",
      headerName: "Branch",
      headerAlign: "center",
      flex: 190,
      align: "left",
      type: "singleSelect",
      editable: !(loanClosed === true || screenMode !== "EditScreen"),
      valueOptions: filterValues.branch.map((data) => data.label),
    },
    {
      field: "applicationNumber",
      headerName: "Application Number",
      headerAlign: "center",
      flex: 200,
      align: "left",
      type: "singleSelect",
      editable: !loanClosed && screenMode === "EditScreen",
      valueOptions: applicationArray,
    },
    {
      field: "glAccount",
      headerName: "GL Account",
      headerAlign: "center",
      align: "left",
      flex: 180,
      editable: !loanClosed && screenMode === "EditScreen",
      type: "singleSelect",
      valueOptions: GLAccountArray,
      disableColumnMenu: true,
    },
    {
      field: "description",
      headerName: "GL Account Description",
      headerAlign: "center",
      flex: 430,
      align: "left",
      disableColumnMenu: true,
    },

    {
      field: "debitAmount",
      headerName: "Debit Amount",
      headerAlign: "center",
      align: "right",
      flex: 180,
      editable: screenMode === "EditScreen" && loanClosed !== true,
      type: "number",
    },
    {
      field: "actions",
      headerName: "Bank Details",
      headerAlign: "center",
      align: "center",
      flex: 100,
      type: "action",
      renderCell: (params) => {
        if (params.row.applicationNumber) {
          return (
            <Tooltip title="Bank Details">
              <IconButton
                onClick={() => {
                  customerBankDetailDialogHandler(params);
                }}
              >
                <AccountBalanceIcon />
              </IconButton>
            </Tooltip>
          );
        }
      },
    },
    {
      field: "icon",
      headerName: "",
      headerAlign: "center",
      align: "left",
      flex: 25,
      type: "number",
      disableColumnMenu: true,
      sortable: false,
      editable: screenMode === "EditScreen" && loanClosed !== true,
      renderCell: (params) => {
        return (
          <Tooltip title="Delete">
            <IconButton disabled={params.row.loanCloseStatus}>
              <Delete
                onClick={() => {
                  deleteSelectedRow(params);
                }}
              ></Delete>
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const getSelectedBranchCode = (branchValue) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.label === branchValue;
    });
    return branchCodeValue.code;
  };

  const getAppListByBranch = async (value) => {
    const branchCodeValue = getSelectedBranchCode(value);
    const response = await axios.post("/losCustomer/getAppListByBranch", {
      branchName: value,
      branchCode: branchCodeValue,
      screenMode: "MODIFY",
    });
    dispatch(
      FilePaymentModifyReducerAction.updateApplicationArray(response.data)
    );
  };
  const onRowClickHandler = (params) => {
    getAppListByBranch(params.applicationBranch);
    getGlAccountsBasedOnBranch(params.applicationBranch);
    setLoanClosed(params.loanCloseStatus);
  };
  const bindCustomerData = async (data, params, dataIndex) => {
    try {
      const response = await axios.post(
        "/losCustomer/getCustBankDetailsByAppNum",
        {
          applicationNum: params.value,
        }
      );
      const emiResponse = await axios.post("/filepayment/getDisbEmiData", {
        applicationNum: params.value,
      });

      const customerBankDetails = response.data[0];
      const datas = {
        ...data,
        glAccount: "",
        description: "",
        debitAmount: "",
        applicationNumber: params.value,
        emiStartDate:
          emiResponse.data.emiStartDate !== undefined
            ? emiResponse.data.emiStartDate
            : null,
        emiAmt:
          emiResponse.data.emiAmt !== undefined ? emiResponse.data.emiAmt : "",
        customerName: customerBankDetails.accHoldrName,
        bankName: customerBankDetails.bankName,
        bankBranchName: customerBankDetails.bankBranchName,
        accountType: customerBankDetails.bankAccountType,
        ifsc: customerBankDetails.ifscCode,
        bankAccNum: customerBankDetails.bankAccountNum,
      };
      let newItem = [...rows];
      newItem[dataIndex] = datas;
      dispatch(FilePaymentModifyReducerAction.updateRows(newItem));
    } catch {
      const datas = {
        ...data,
        applicationNumber: params.value,
        customerName: "",
        bankName: "",
        bankBranchName: "",
        ifsc: "",
        bankAccNum: "",
        debitAmount: "",
      };
      let newItem = [...rows];
      newItem[dataIndex] = datas;
      dispatch(FilePaymentModifyReducerAction.updateRows(newItem));
    }
  };
  const getGlAccountsBasedOnBranch = (branch) => {
    if (branch === "" || branch === null) {
      dispatch(FilePaymentModifyReducerAction.updateGLValAndDesArray([]));
      dispatch(FilePaymentModifyReducerAction.updateGLAccountArray([]));
    } else {
      const selectedBranch = filterValues.brachArrayWithCode.find(
        (branchVal) => {
          return branchVal.label === branch;
        }
      );
      const GlDetails = allBranchGlAccounts[selectedBranch.code];
      const GLValAndDesArray = GlDetails.ledger_details.map((data) => data);
      dispatch(
        FilePaymentModifyReducerAction.updateGLValAndDesArray(GLValAndDesArray)
      );

      const GlAccount = GlDetails.ledger_details.map((data) => {
        return `${data["account_head"]} - ${data["account_desc"]}`;
      });
      dispatch(FilePaymentModifyReducerAction.updateGLAccountArray(GlAccount));
    }
  };
  //Cell Change Handler
  const cellChangeHandler = async (params) => {
    const dataIndex = rows.findIndex((data) => {
      return data.id === params.id;
    });
    let data = rows[dataIndex];
    if (params.field === "glAccount") {
      const activeRowValue = rows.find((data) => {
        return data.id === activeRowID;
      });
      getGlAccountsBasedOnBranch(activeRowValue.applicationBranch);

      const filterValue = rows.map((data) => {
        return activeRowValue.applicationNumber === data.applicationNumber
          ? data
          : "";
      });
      let clearFlag;
      if (
        `${activeRowValue.glAccount} - ${activeRowValue.description}` ===
        params.value
      ) {
        clearFlag = false;
      } else {
        filterValue.forEach((data) => {
          const retrivalData = GLResponseData.find((data) => {
            return (
              `${data["account_head"]} - ${data["account_desc"]}` ===
              params.value
            );
          });
          if (data.glAccount === retrivalData.account_head) {
            clearFlag = true;
          }
        });
      }

      let datas;
      if (clearFlag) {
        setinformationDialogOkButton(true);
        setValidationDialogTitle("Information");
        setValidationDialogContent(
          `This GL Account ${params.value} Is Already Used.`
        );
        setDialogTitleMode("ValidationDialogMode");

        setValidationDialogOpen(true);
        datas = {
          ...data,
          glAccount: "",
          description: "",
        };
      } else {
        const retrivalData = GLResponseData.find((data) => {
          return (
            `${data["account_head"]} - ${data["account_desc"]}` === params.value
          );
        });
        const response = await checkGlPaymentReceipt(
          activeRowValue.applicationNumber,
          retrivalData.account_head
        );
        if (response.data.status === 1) {
          datas = {
            ...data,
            glAccount: retrivalData.account_head,
            description: retrivalData.account_desc,
          };
          const exeArray = Gldes.find((data) => {
            return data.applicationNumber === activeRowValue.applicationNumber;
          });
          if (exeArray) {
            const dataIndex = Gldes.findIndex((data) => {
              return data.applicationNumber === exeArray.applicationNumber;
            });
            let datasR = {
              ...exeArray,
              data: [
                ...exeArray.data,
                // { GLNumber: params.value, amount: retrivalData.creditAmt },
                { GLNumber: params.value },
              ],
            };
            let newItems = [...Gldes];
            newItems[dataIndex] = datasR;
            dispatch(
              FilePaymentModifyReducerAction.updateValidationGlDes(newItems)
            );
          } else {
            let data = {
              applicationNumber: activeRowValue.applicationNumber,
              // data: [{ GLNumber: params.value, amount: retrivalData.creditAmt }],
              data: [{ GLNumber: params.value }],
            };
            let newItemss = [...Gldes];

            newItemss.push(data);
            dispatch(
              FilePaymentModifyReducerAction.updateValidationGlDes(newItemss)
            );
          }
        } else {
          datas = {
            ...data,
            glAccount: "",
            description: "",
          };
          setInformationDialogFlag(true);
          setInformationDialogTitle(response.data.message);
        }
      }

      let newItem = [...rows];
      newItem[dataIndex] = datas;
      dispatch(FilePaymentModifyReducerAction.updateRows(newItem));
    } else if (params.field === "applicationBranch") {
      getAppListByBranch(params.value);
      const branchCode = brachArrayWithCode.find((branch) => {
        return params.value === branch.label;
      });

      const datas = {
        ...data,
        applicationBranch: params.value,
        applicationNumber: "",
        applicationBranchCode: branchCode.code,
        glAccount: "",
        description: "",
        debitAmount: "",
      };
      let newItem = [...rows];
      newItem[dataIndex] = datas;
      dispatch(FilePaymentModifyReducerAction.updateRows(newItem));
    } else if (params.field === "applicationNumber") {
      bindCustomerData(data, params, dataIndex);
    } else if (params.field === "debitAmount") {
      const response = await checkPaymentGlReceiptAmount(
        data.applicationNumber,
        data.glAccount,
        params.value
      );
      let datas;
      if (response.data.status === 1) {
        datas = {
          ...data,
          debitAmount:
            params.value <= 0 || Number(params.value) > 99999999
              ? 0
              : Math.floor(params.value),
        };
      } else {
        datas = {
          ...data,
          debitAmount: 0,
        };
        setInformationDialogFlag(true);
        setInformationDialogTitle(response.data.message);
      }

      let newItem = [...rows];
      newItem[dataIndex] = datas;
      dispatch(FilePaymentModifyReducerAction.updateRows(newItem));
    } else {
      const datas = { ...data, [params.field]: params.value };
      let newItem = [...rows];
      newItem[dataIndex] = datas;
      dispatch(FilePaymentModifyReducerAction.updateRows(newItem));
    }
  };
  function handleOnCellKeyDown(params, event) {
    console.log(params, event);
    if (params.field === "debitAmount") {
      const dataIndex = rows.findIndex((data) => {
        return data.id === params.id;
      });
      let data = rows[dataIndex];
      const datas = {
        ...data,
        debitAmount:
          event.target.value <= 0 || Number(event.target.value) > 99999999
            ? 0
            : Math.floor(event.target.value),
      };
      let newItem = [...rows];
      newItem[dataIndex] = datas;
      dispatch(FilePaymentModifyReducerAction.updateRows(newItem));
    }
  }
  return (
    <>
      <Box
        sx={{
          color: "red",
          background: "white",
          padding: "0.8rem",
          borderRadius: "0.4rem",
        }}
      >
        {!approvalFlag && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "right",
              marginBottom: "8px",
            }}
          >
            {screenMode === "EditScreen" && (
              <Tooltip title="Ctrl+A">
                <Button
                  variant="contained"
                  onClick={gridRowAddButtonHandler}
                  sx={{
                    marginLeft: "1rem",
                    color: "white",
                    fontWeight: "bold",
                  }}
                  ref={addRowRef}
                >
                  <AddIcon />
                </Button>
              </Tooltip>
            )}
            {screenMode === "EditScreen" && (
              <Tooltip title="Ctrl+S">
                <Button
                  sx={{ fontWeight: "bold", marginLeft: "12px" }}
                  variant="contained"
                  onClick={UpdateBtn}
                  disabled={rows.length == 0 || saveRequestActive}
                  ref={saveUpdateRef}
                >
                  <SaveIcon />
                </Button>
              </Tooltip>
            )}
            {screenMode === "DeleteScreen" && (
              <Tooltip title="Ctrl+S">
                <Button
                  sx={{ fontWeight: "bold", marginLeft: "12px" }}
                  variant="contained"
                  disabled={rows.length == 0 || saveRequestActive}
                  onClick={deleteButton}
                  ref={saveDeleteRef}
                >
                  <SaveIcon />
                </Button>
              </Tooltip>
            )}
            {screenMode === "ApprovalScreen" && (
              <Tooltip title="Ctrl+S">
                <Button
                  sx={{ fontWeight: "bold", marginLeft: "12px" }}
                  variant="contained"
                  disabled={rows.length == 0 || saveRequestActive}
                  onClick={approvalBtn}
                  ref={saveApproveRef}
                >
                  <SaveIcon />
                </Button>
              </Tooltip>
            )}
          </Box>
        )}
        {useMediaQuery("(min-width:1200px)") && (
          <CustomDataGrid
            noDataMessage="No Data."
            noDataOnFilterMessage="No Data on Applied Filter."
            rows={rows}
            gridHeight={
              rows.length < 5 && rows.length !== 0
                ? rows.length * 40 + 130
                : 330
            }
            onPageSizeChange={(pageSize) => {
              setPageSize(pageSize);
            }}
            columns={column}
            pageSize={pageSize}
            pageSizeOptions={[5, 10, 15, 20, 25]}
            onCellEditCommit={(params) => {
              cellChangeHandler(params);
            }}
            onCellKeyDown={(params, event) => {
              (event.key === "e" ||
                event.key === "E" ||
                event.key === "." ||
                event.key.includes("-")) &&
                event.preventDefault();
              handleOnCellKeyDown(params, event);
            }}
            onRowClick={(params) => {
              setActiveRowID(params.id);
              onRowClickHandler(params.row);
            }}
            gridLazyLoad={() => {}}
            onSortModelChange={() => {}}
            isCellEditable={() => true}
            // //Visibility
            // initialState={{
            //   columns: {
            //     columnVisibilityModel: {
            //       icon:
            //         screenMode === "ViewScreen"
            //           ? false
            //           : screenMode === "DeleteScreen"
            //           ? false
            //           : approvalMode
            //           ? false
            //           : true,
            //     },
            //   },
            // }}
          />
        )}
        {useMediaQuery("(max-width:1200px)") && (
          <Paper sx={{ marginBottom: "8px", padding: "0px 16px 8px 16px" }}>
            <React.Fragment>
              <Grid
                container
                item
                direction="row"
                alignItems="flex-end"
                justifyContent="flex-end"
                sx={{ height: "60px", bgcolor: "white" }}
              >
                {totalRowsCount > 10 && (
                  <Typography
                    sx={{
                      mr: 2,
                      color: "#004A92",
                      fontWeight: 700,
                    }}
                  >
                    {"Page Max Records : " + rowsPerPage}
                  </Typography>
                )}
                <Typography
                  padding="1px"
                  sx={{
                    color: "#004A92",
                    fontWeight: 700,
                  }}
                >
                  {"Total Records : " + totalRowsCount}
                </Typography>
                <Pagination
                  count={totalPageCount}
                  color="primary"
                  onChange={handlePageChange}
                  page={page}
                  renderItem={(item) => (
                    <PaginationItem
                      slots={{ previous: ArrowBack, next: ArrowForward }}
                      {...item}
                    />
                  )}
                />
              </Grid>
              <Grid container>
                <Box
                  sx={{
                    height: accordianOpen
                      ? window.innerHeight - 540
                      : window.innerHeight - 250,
                    overflow: "auto",
                    flex: "1 auto",
                    marginBottom: "16px",
                  }}
                >
                  <Box>
                    <Grid container rowSpacing={0} columnSpacing={1}>
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        {screenMode === "DeleteScreen" && !approvalFlag && (
                          <CustomTextField
                            label="Remarks"
                            variant="standard"
                            value={deleteRemarks}
                            onChange={(e, value) => {
                              dispatch(
                                FilePaymentModifyReducerAction.updateRemarks(
                                  e.target.value
                                )
                              );
                            }}
                            onBlur={() => {
                              dispatch(
                                FilePaymentModifyReducerAction.updateRemarksTouchHandler(
                                  true
                                )
                              );
                            }}
                          />
                        )}
                        {deleteRemarksHasError &&
                          screenMode === "DeleteScreen" &&
                          !approvalFlag && (
                            <p className="error">Please Enter Valid Remarks.</p>
                          )}
                      </Grid>
                    </Grid>
                  </Box>
                  {datarows.map((row, index) => (
                    <React.Fragment>
                      <Grid
                        container
                        direction="column"
                        sx={{ flex: "1 auto" }}
                      >
                        <Card>
                          <CardHeader
                            subheader={
                              "Branch - GLAcc : " +
                              row.applicationBranch +
                              " - " +
                              row.glAccount
                            }
                            subheaderTypographyProps={{
                              color: "#004A92",
                              fontWeight: "700",
                            }}
                            action={
                              <React.Fragment>
                                {screenMode === "EditScreen" && (
                                  <IconButton size="small">
                                    <Delete
                                      fontSize="small"
                                      sx={{ color: "#004A92", fontWeight: 700 }}
                                      onClick={() => {
                                        let params = {
                                          id: row.id,
                                        };
                                        deleteSelectedRow(params);
                                      }}
                                    />
                                  </IconButton>
                                )}
                              </React.Fragment>
                            }
                            sx={{
                              textAlign: "left",
                              padding: "16px 16px 0px 16px !important",
                            }}
                          />
                          <CardContent sx={{}}>
                            <Grid
                              container
                              item
                              direction="column"
                              alignItems="flex-start"
                              justifyContent="flex-start"
                              sx={{}}
                            >
                              <Grid
                                container
                                rowSpacing={1}
                                direction="row"
                                alignItems="flex-start"
                                justifyContent="flex-start"
                              >
                                <React.Fragment>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Branch"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    <span
                                      style={{
                                        display: "flex",
                                      }}
                                    >
                                      {` :  `}

                                      <CustomAutoComplete
                                        variant="standard"
                                        type="text"
                                        placeholder="Select Branch"
                                        disabled={screenMode !== "EditScreen"}
                                        autoCompleteValues={filterValues.branch.map(
                                          (data) => data.label
                                        )}
                                        value={row.applicationBranch}
                                        onChange={(e, value) => {
                                          let params = {
                                            id: row.id,
                                            field: "applicationBranch",
                                            value: value,
                                          };
                                          cellChangeHandler(params);
                                          setActiveRowID(params.id);
                                        }}
                                      />
                                    </span>
                                  </Grid>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Application Number"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    <span
                                      style={{
                                        display: "flex",
                                      }}
                                    >
                                      {` : `}

                                      <CustomAutoComplete
                                        variant="standard"
                                        type="text"
                                        placeholder="Select Application Number"
                                        autoCompleteValues={applicationArray}
                                        disabled={screenMode !== "EditScreen"}
                                        value={row.applicationNumber}
                                        onChange={(e, value) => {
                                          let params = {
                                            id: row.id,
                                            field: "applicationNumber",
                                            value: value,
                                          };
                                          cellChangeHandler(params);
                                          setActiveRowID(params.id);
                                        }}
                                        onOpen={(e, value) => {
                                          let params = {
                                            id: row.id,
                                            field: "applicationNumber",
                                            value: value,
                                            applicationBranch:
                                              row.applicationBranch,
                                          };
                                          getAppListByBranch(
                                            params.applicationBranch
                                          );
                                        }}
                                      />
                                    </span>
                                  </Grid>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"GL Account"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    <span
                                      style={{
                                        display: "flex",
                                      }}
                                    >
                                      {` : `}

                                      <CustomAutoComplete
                                        variant="standard"
                                        type="text"
                                        placeholder="Select Gl Account"
                                        autoCompleteValues={GLAccountArray}
                                        value={row.glAccount}
                                        disabled={screenMode !== "EditScreen"}
                                        onChange={(e, value) => {
                                          let params = {
                                            id: row.id,
                                            field: "glAccount",
                                            value: value,
                                          };
                                          cellChangeHandler(params);
                                          setActiveRowID(params.id);
                                        }}
                                        onOpen={(e, value) => {
                                          let params = {
                                            id: row.id,
                                            field: "glAccount",
                                            value: value,
                                            applicationBranch:
                                              row.applicationBranch,
                                          };
                                          getGlAccountsBasedOnBranch(
                                            params.applicationBranch
                                          );
                                        }}
                                      />
                                    </span>
                                  </Grid>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Gl Account Desc"}
                                    </Typography>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={5}
                                    md={7}
                                    sx={{
                                      color:
                                        screenMode !== "EditScreen"
                                          ? "#888"
                                          : null,
                                    }}
                                  >
                                    {` :  ${
                                      row.description !== null &&
                                      row.description !== undefined &&
                                      row.description !== ""
                                        ? row.description
                                        : "-----------------------"
                                    }`}
                                  </Grid>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Credit Amount"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    {` : `}

                                    <TextField
                                      autoComplete="off"
                                      sx={{
                                        "& .MuiInputBase-input": {
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        },
                                      }}
                                      inputProps={{
                                        // inputMode: "numeric",
                                        // pattern: "[0-9]*",
                                        style: {
                                          textAlign: `left`,
                                          fontSize: "12px",
                                        },
                                      }}
                                      type="number"
                                      variant="standard"
                                      value={row.debitAmount}
                                      disabled={screenMode !== "EditScreen"}
                                      placeholder="Please Enter Debit Amount"
                                      onChange={(event) => {
                                        let params = {
                                          id: row.id,
                                          field: "debitAmount",
                                          value: event.target.value,
                                        };
                                        cellChangeHandler(params);
                                        setActiveRowID(params.id);
                                      }}
                                      onBlur={() => {}}
                                      onKeyDown={(e) => {
                                        if (
                                          e.key === "e" ||
                                          e.key === "E" ||
                                          e.key === "-" ||
                                          e.key === "+" ||
                                          e.key === "."
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                  </Grid>
                                </React.Fragment>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>
                      <Divider />
                    </React.Fragment>
                  ))}
                </Box>
              </Grid>
            </React.Fragment>
          </Paper>
        )}
        {useMediaQuery("(min-width:1200px)") && (
          <Box>
            <Grid container rowSpacing={0} columnSpacing={1}>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                {screenMode === "DeleteScreen" && !approvalFlag && (
                  <CustomTextField
                    label="Remarks"
                    variant="standard"
                    value={deleteRemarks}
                    onChange={(e, value) => {
                      dispatch(
                        FilePaymentModifyReducerAction.updateRemarks(
                          e.target.value
                        )
                      );
                    }}
                    onBlur={() => {
                      dispatch(
                        FilePaymentModifyReducerAction.updateRemarksTouchHandler(
                          true
                        )
                      );
                    }}
                  />
                )}
                {deleteRemarksHasError &&
                  screenMode === "DeleteScreen" &&
                  !approvalFlag && (
                    <p className="error">Please Enter Valid Remarks.</p>
                  )}
              </Grid>
            </Grid>
          </Box>
        )}
      </Box>
      <Dialog open={Dialogopen}>
        <DialogTitle>
          <h4>Bank Details</h4>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              padding: "8px",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <CustomTextField
                  type="text"
                  variant="standard"
                  label="Applicant Name"
                  value={modalValues.customerName}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomTextField
                  type="text"
                  label="Bank Name"
                  variant="standard"
                  value={modalValues.bankName}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomTextField
                  type="text"
                  label="Bank Branch Name"
                  variant="standard"
                  value={modalValues.bankBranchName}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomDateField
                  label="EMI Start Date"
                  variant="standard"
                  disabled={true}
                  value={modalValues.emiStartDate}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomTextField
                  type="text"
                  label="IFSC"
                  variant="standard"
                  value={modalValues.ifsc}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomTextField
                  type="text"
                  label="Bank Account Number"
                  variant="standard"
                  value={modalValues.bankAccNum}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomTextField
                  variant="standard"
                  type="text"
                  label="Account Type"
                  value={modalValues.accountType}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomTextField
                  type="text"
                  label="Current EMI"
                  variant="standard"
                  disabled={true}
                  value={
                    modalValues.emiAmt === ""
                      ? ""
                      : parseInt(modalValues.emiAmt).toLocaleString("en-IN")
                  }
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+K" placement="top">
            <Button
              onClick={() => {
                setDialogOpen(false);
              }}
              ref={okRef}
            >
              OK
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Dialog
        open={validationDialogOpen}
        sx={{
          "& div.css-1t1j96h-MuiPaper-root-MuiDialog-paper": {
            maxWidth: { xs: "95%", md: "95%", lg: "95%" },
          },
        }}
      >
        <DialogTitle>
          <h4>{validationDialogTitle}</h4>
        </DialogTitle>
        <DialogContent>{validationDialogContent}</DialogContent>
        <DialogActions>
          {!informationDialogOkButton && (
            <Tooltip title="Ctrl+K" placement="top">
              <Button
                onClick={() => {
                  window.location.reload(true);
                  setValidationDialogOpen(false);
                }}
                ref={okValRef}
              >
                OK
              </Button>
            </Tooltip>
          )}
          {informationDialogOkButton && (
            <Tooltip title="Ctrl+K" placement="top">
              <Button
                onClick={() => {
                  setValidationDialogOpen(false);
                }}
                ref={okInfoRef}
              >
                OK
              </Button>
            </Tooltip>
          )}
        </DialogActions>
      </Dialog>
      <Dialog
        open={confirmationDialogOpen}
        sx={{
          "& div.css-1t1j96h-MuiPaper-root-MuiDialog-paper": {
            maxWidth: { xs: "95%", md: "95%", lg: "95%" },
          },
        }}
      >
        <DialogTitle>
          <h4>{confirmationDialogTitle}</h4>
        </DialogTitle>
        <DialogContent>{confirmationDialogContent}</DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+Q" placement="top">
            <Button
              onClick={() => {
                setConfirmationDialogopen(false);
              }}
              ref={cancelDetRef}
            >
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl+Y" placement="top">
            <Button
              disabled={yesButtonDisableHandler}
              onClick={() => {
                confirmationDialogYesButtonHandler();
              }}
              ref={yesDetRef}
            >
              Yes
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Dialog open={informationDialogFlag}>
        <DialogTitle>
          <h4>Information</h4>
        </DialogTitle>
        <DialogContent>{informationDialogTitle}</DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+Y" placement="top">
            <Button
              disabled={yesButtonDisableHandler}
              onClick={() => {
                setInformationDialogFlag(false);
              }}
            >
              Ok
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      {loading && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "center",
              }}
            >
              <CircularProgress color="inherit" />
              <p>{loadingMsg}</p>
            </Box>
          </Backdrop>
        </>
      )}
    </>
  );
};

export default FilePaymentDet;
